import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import PWAInstallation from "../PWAInstallation";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { AppMode } from "../../../constants";

class Footer extends Component {
  state = {
    active_nearme: false,
    active_explore: false,
    active_cart: false,
    active_account: false,
    active_alerts: false,
    active_relay: false,
    unread_alerts_count: null,
  };

  // Handle Near Me click - custom handler or default navigation
  handleNearMeClick = (e) => {
    if (this.props.onNearMeClick) {
      e.preventDefault(); // Prevent navigation
      this.props.onNearMeClick();
      this.setState({ active_nearme: true, active_explore: false, active_cart: false, active_account: false, active_alerts: false });
    }
    // If no custom handler, let NavLink handle the navigation normally
  };

  componentDidMount() {
    if (this.props.active_nearme === true) {
      this.setState({ active_nearme: true });
    }
    if (this.props.active_explore === true) {
      this.setState({ active_explore: true });
    }
    if (this.props.active_cart === true) {
      this.setState({ active_cart: true });
    }
    if (this.props.active_account === true) {
      this.setState({ active_account: true });
    }
    if (this.props.active_alerts === true) {
      this.setState({ active_alerts: true });
    }
    if (this.props.active_relay === true) {
      this.setState({ active_relay: true });
    }
  }

  // Helper method to determine if this is Phase 2 (Relay)
  isPhase2 = () => {
    return this.props.appMode === AppMode.RELAY;
  }

  getTotalItemsInCart = () => {
    const { cartProducts, phase2CartProducts, cartTotal } = this.props;
    
    // Get appropriate cart products based on app mode
    const currentCartProducts = this.isPhase2() ? phase2CartProducts : cartProducts;
    
    if (localStorage.getItem("countQuantityAsTotalItemsOnCart") === "true") {
      let total = 0;
      currentCartProducts.forEach((item) => {
        total += item.quantity;
      });
      return total;
    } else {
      // For Phase 2, calculate total manually since cartTotal is for Phase 1 only
      if (this.isPhase2()) {
        return phase2CartProducts.length;
      }
      return cartTotal.productQuantity;
    }
  };

  render() {
    const { alertUnreadTotal } = this.props;
    const isPhase2 = this.isPhase2();

    // console.log('🦶 Footer - App Mode:', isPhase2 ? 'Phase 2 (Relay)' : 'Phase 1 (Sprint)');
    // console.log('🦶 Footer - Cart Items Count:', this.getTotalItemsInCart());

    return (
      <React.Fragment>
        {localStorage.getItem("showPwaInstallPromptFooter") === "true" && (
          <PWAInstallation type={"footer"} />
        )}

        <div className="d-flex justify-content-center align-items-center">
          <div
            className={`content pt-10 font-size-xs clearfix ${
              localStorage.getItem("footerStyleType") === "FLOAT"
                ? "footer-float"
                : "footer-fixed"
            }`}
          >
            {/* Near Me Tab - Changes route based on app mode or uses custom handler */}
            <NavLink 
              to={isPhase2 ? "/phase2" : "/"} 
              className="col footer-links px-2 py-1 anchor-link"
              onClick={this.handleNearMeClick}
            >
              <LocationOnOutlinedIcon style={{ 
                fontSize: '28px',
                verticalAlign: 'middle',
                marginTop: '-4px',
                color: this.state.active_nearme ? '#2B2A29' : 'inherit'
              }} />
              <br />
              <span className={this.state.active_nearme ? "active-footer-tab" : ""}>
                {this.state.active_nearme ? (
                  localStorage.getItem("footerNearme")
                ) : (
                  <span>{localStorage.getItem("footerNearme")}</span>
                )}
              </span>
            </NavLink>
            
            {/* Alerts Tab */}
            <NavLink
              to="/alerts"
              className="col footer-links px-2 py-1 anchor-link"
            >
              {alertUnreadTotal > 0 && <span className="notification-badger" />}
              <NotificationsNoneRoundedIcon style={{ 
                fontSize: '28px',
                verticalAlign: 'middle',
                marginTop: '-4px',
                color: this.state.active_alerts ? '#2B2A29' : 'inherit'
              }} />
              <br />
              <span
                className={this.state.active_alerts ? "active-footer-tab" : ""}
              >
                {this.state.active_alerts ? 
                  localStorage.getItem("footerAlerts") : 
                  <span>{localStorage.getItem("footerAlerts")}</span>
                }
              </span>
            </NavLink>
            
            {/* Explore Tab - Changes route based on app mode */}
            <NavLink
              to={isPhase2 ? "/phase2/explore" : "/explore"}
              className="col footer-links px-2 py-1 anchor-link"
            >
              <SearchOutlinedIcon style={{ 
                fontSize: '28px',
                verticalAlign: 'middle',
                marginTop: '-4px',
                color: this.state.active_explore ? '#2B2A29' : 'inherit'
              }} />
              <br />
              <span
                className={this.state.active_explore ? "active-footer-tab" : ""}
              >
                {this.state.active_explore
                  ? localStorage.getItem("footerExplore")
                  : localStorage.getItem("footerExplore")}
              </span>
            </NavLink>
            
            {/* Cart Tab - Shows appropriate cart count */}
            <NavLink
              to="/cart"
              className="col footer-links px-2 py-1 anchor-link"
            >
              <img 
                src="/assets/img/logos/ELECATEICON-4.svg" 
                alt="Cart"
                style={{ 
                  width: '28px', 
                  height: '28px',
                  verticalAlign: 'middle',
                  marginTop: '-4px'
                }} 
              />
              <br />
              <span
                className={this.state.active_cart ? "active-footer-tab" : ""}
              >
                {this.state.active_cart
                  ? localStorage.getItem("footerCart")
                  : localStorage.getItem("footerCart")}
                <span className="cart-quantity-badge">
                  {this.getTotalItemsInCart()}
                </span>
              </span>
            </NavLink>
            
            {/* Account Tab - Changes route based on app mode */}
            <NavLink
              to={isPhase2 ? "/phase2/my-account" : "/my-account"}
              className="col footer-links px-2 py-1 anchor-link"
            >
              <PersonOutlineOutlinedIcon style={{ 
                fontSize: '28px',
                verticalAlign: 'middle',
                marginTop: '-4px',
                color: this.state.active_account ? '#2B2A29' : 'inherit'
              }} />
              <br />
              <span
                className={this.state.active_account ? "active-footer-tab" : ""}
              >
                {this.state.active_account
                  ? localStorage.getItem("footerAccount")
                  : localStorage.getItem("footerAccount")}
              </span>
            </NavLink>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  cartTotal: state.total.data,
  cartProducts: state.cart.products,
  phase2CartProducts: state.cart.phase2Products || [],
  alertUnreadTotal: state.alert.alertUnreadTotal,
  appMode: state.settings.appMode,
});

export default connect(
  mapStateToProps,
  {}
)(Footer);
